export default __webpack_public_path__ + "static/media/success.258fd79d.jpg";